// util funcions for surveys single and multiple choice questons with "something else" option

export const OTHER_OPTION_VALUE = '__other__';
export const MIN_OPTIONS_FOR_DROPDOWN_VIEW = 4;
export interface OtherResponse {
  value: typeof OTHER_OPTION_VALUE;
  text: string;
}

export interface MultipleChoiceWithOther {
  selected: string[];
  other_text: string;
}

export function isOtherOptionSelected(
    value: any, 
    questionType: 'single_choice' | 'multiple_choice'
): boolean {
  if (questionType === 'single_choice') {
    return (
      value === OTHER_OPTION_VALUE ||
      (typeof value === 'object' &&
       value !== null &&
       value.value === OTHER_OPTION_VALUE)
    );
  }
  
  if (questionType === 'multiple_choice') {
    if (Array.isArray(value)) {
      return value.includes(OTHER_OPTION_VALUE);
    }
    if (typeof value === 'object' && value !== null) {
      return value.selected?.includes(OTHER_OPTION_VALUE) || false;
    }
  }
  
  return false;
}

export function getSelectedOptions(
  value: any,
  questionType: 'single_choice' | 'multiple_choice'
): string[] {
  if (questionType === 'single_choice') {
    if (typeof value === 'object' && value !== null && value.value) {
      return [value.value];
    }
    return value ? [value] : [];
  }
  
  if (questionType === 'multiple_choice') {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === 'object' && value !== null && value.selected) {
      return value.selected;
    }
  }
  
  return [];
}

export function getOtherText(
  value: any,
  questionType: 'single_choice' | 'multiple_choice'
): string {
  if (questionType === 'single_choice') {
    if (value === OTHER_OPTION_VALUE) {
      return '';
    }
    if (typeof value === 'object' && value !== null && value.value === OTHER_OPTION_VALUE) {
      return value.text || '';
    }
  }
  
  if (questionType === 'multiple_choice') {
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      return value.other_text || '';
    }
  }
  
  return '';
}

export function createSingleChoiceResponse(option: string, otherText?: string): string | OtherResponse {
  if (option === OTHER_OPTION_VALUE && otherText !== undefined && otherText !== '') {
    return { value: OTHER_OPTION_VALUE, text: otherText };
  }
  return option;
}

export function createMultipleChoiceResponse(
  selected: string[],
  otherText?: string
): string[] | MultipleChoiceWithOther {
  const hasOther = selected.includes(OTHER_OPTION_VALUE);
  
  if (hasOther && otherText !== undefined && otherText !== '') {
    return { selected, other_text: otherText };
  }
  
  return selected;
}

